import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { data } from "src/app/audit-trail/application/data";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { AllotmentLetterListModel } from "src/app/model/AllotmentLetterListModel";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
import { DocumentVerificationService } from "src/app/services/document-verification.service";
import { ExportImportService } from "src/app/services/export-import.service";
import { MasterService } from "src/app/services/master.service";
import { OfficialsService } from "src/app/services/officials.service";
import { PublishLettersService } from "src/app/services/publish-letters.service";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "app-secure-report_e_billing",
  templateUrl: "./report_e_billing.component.html",
  styleUrls: ["./report_e_billing.component.scss"],
})
export class EBillingReportComponent implements OnInit {
  [x: string]: any;
  isLoading: boolean = false;
  lotteryList: {[key: number]: string};
  boardValue:boolean =false;
  lotteryValue:boolean =false;
  isSubmitDisabled: boolean = false;
  downloadedBatches: string[] = [];
  boards: {[key: number]: string};
  board:any;
  lottery:any;
  startDate:any;
  endDate:any;
  schemeList: {[key: number]: string};
  scheme:any;
 

  
  constructor(
    private router: Router,
    private exportImportService: ExportImportService,
    private reportService:ReportService,
    private publishLetterService: PublishLettersService,
    private auditTrailService: AuditTrailService, 
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private masterService: MasterService,


  ) {}

  ngOnInit(): void {
    this.loadData();


    this.startDateControl = new FormControl();
    this.startDateControl.valueChanges.subscribe((startDate) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (new Date(startDate) <= today) {
        this.startDateControl.setErrors(null);
      } else {
        this.startDateControl.setErrors({ futureDate: true });
      }
    });

    this.endDateControl = new FormControl();
    this.endDateControl.valueChanges.subscribe((endDate) => {
      if (endDate > new Date()) {
        this.endDateControl.setErrors({ futureDate: true });
      } else {
        this.endDateControl.setErrors(null);
      }
    });


    this.form = new FormGroup({
      boardKey: new FormControl(null, Validators.required),
      lottery: new FormControl(null, Validators.required),

      startDate: new FormControl(null, Validators.required),
      endDate: new FormControl(null, Validators.required),
      
    });

   
  }

 

  validateEndDate() {
    return new Date(this.form.value.endDate) < new Date(this.form.value.startDate)
    ? true
    : false;
  }
  

  loadData() {

    this.reportService.initQueryExecutorForm().subscribe((data)=>{
      this.boards= data.boards;
      console.log(data);
    })


    

    // this.publishLetterService
    // .publishDocumentsInitForm()
    // .subscribe((data: any) => {
    //    this.isLoading = false;
    //     this.lotteryList = data.lotteryList;
    // }, error => {
    //   this.isLoading = false;
    //   this.publishLetterService.errorToast(error.errorMessage||error.error.errorMessage);
    // });
  
  }

 
  refresh() {
    this.loadData();
  }

  getCurrentDate(): string {
    const currentDate = new Date();
    return this.datePipe.transform(currentDate, 'yyyy-MM-dd') || ''; // Format the date as needed
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }

  onSubmit() {

    if(this.form.value.applicationNo !==null ){
      console.log(this.form.value.applicationNo);
      this.exportImportService.downloadPol(this.form.value.applicationNo)
      .subscribe((data) => {
        this.isLoading = false;
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.downloadedBatches.push(this.form.value.applicationNo);
          this.downloadFile(data.base64File, data.fileName);
          this.successToast();
        }
        else {
          this.exportImportService.errorToast(data.errorMessage);  
        }
      }, error => {
        this.isLoading = false;
        this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
        // this.exportImportService.errorToast("Please Enter Application Number:"+this.form.value.applicationNo);

      });
  
    } else {
      this.exportImportService.errorToast("Please Enter Application Number");  
    }

    
  }
  
  
  async successToast() {
    await this._snackBar.open(
        " E-Billing Report Successfully Downloaded",
        "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
        }
    );
}

onBoardChange(boardId:any){
  this.board=boardId
  this.form.get("startDate").setValue('');
  this.form.get("endDate").setValue('');
  this.auditTrailService.changeLottery(boardId)
  .subscribe((data:LotteryFormResponse) => {
    this.lotteryList=data.lotterylist;
this.BoardValue=!!boardId

console.log(this.lotteryId)
  });
}

resetFilter() {
  // this.form.get("boardKey").setValue(null);
  // this.form.get("lottery").setValue(null);
  // this.form.get("startDate").setValue(null);
  // this.form.get("endDate").setValue(null);
  window.location.reload();
  // this.onLoad();
}


onLotteryChange(lotteryId:any){
  this.lottery=lotteryId,
  this.auditTrailService.getSchemeNameService(lotteryId)
  .subscribe((data:LotteryFormResponse) => {
    this.schemeList=data.schemeList;
this.lotteryValue=!!lotteryId
    
    console.log(this.schemeList)

  });
}


DownloadEBillingRepor() {

  if (this.validateEndDate()) {
    this.masterService.errorToast("End Date should be greater than Start Date");
    this.isSubmitDisabled = false; // Make sure this is set accordingly
    return;
  }


    this.isLoading = true;
    let payload: any ={
      boardId:this.board,
      lotteryId:this.lottery,
      startDate:this.form.get('startDate').value,
      endDate:this.form.get('endDate').value,
      
    }
     console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>",payload);

    this.auditTrailService.DownloadEBillingReportURLs(payload)
    .subscribe((data) => {
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.downloadFile(data.data, data.fileName);
        this.successToast();
       this. resetFilter()
      }
      else {
        this.exportImportService.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
      // this.exportImportService.errorToast("Please Enter Application Number:"+this.form.value.applicationNo);

    });


    
}

}